import { AxiosInstance } from "axios";

export default class RenewalEmailService {
  private _endpoint = "RenewalEmail";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async markLinkClicked(
    renewalEmailId: string,
    abortController?: AbortController,
  ): Promise<void> {
    await this._client.post(
      `${this._endpoint}/mark-link-clicked/${renewalEmailId}`,
      {},
      { signal: abortController?.signal },
    );
  }
}
